import { MESSAGE_BOX_SHOW, MESSAGE_BOX_HIDE } from './type'

//eslint-disable-next-line
export default function (
  state = {
    contents: [],
  },
  action,
) {
  switch (action.type) {
    case MESSAGE_BOX_SHOW:
      const { content } = action.payload
      return {
        ...state,
        contents: [...state.contents, content],
      }
    case MESSAGE_BOX_HIDE:
      const { id } = action.payload
      if (state.contents.length === 1) {
        return {
          ...state,
          contents: [],
        }
      }
      const draggables = state.contents.filter(x => x.draggable == true).length
      if (
        state.contents.length - draggables > 0 &&
        state.contents[0]?.title !== 'Select page type' &&
        state.contents[0]?.title === 'Landing page settings'
      ) {
        return {
          ...state,
          contents: state.contents.filter(cc => cc.draggable == true),
        }
      }

      if (id) {
        const messageBoxIndex = id.split('message-box-')[1]

        return {
          ...state,
          contents: state.contents.filter(
            (_, index) => index !== Number(messageBoxIndex),
          ),
        }
      }
      return {
        ...state,
        contents: [],
      }
    default:
      return state
  }
}
